import styled from 'styled-components';

export const FacilityCalendarHomeContainer = styled.div`
height: ${(props) => `${props.$height}`};
width: ${(props) => `${props.$width}`};
position: relative;
margin-top: 5%;
`